export default __webpack_public_path__ + "3703f3c.png";